module.exports = __webpack_public_path__ + "img/xsh.6da172d6.png";